<wlx-tabs>
  <wlx-tab [title]="'reports.report-files.custom-reports' | translate | titlecase">
    <wl-report-custom-report-files></wl-report-custom-report-files>
  </wlx-tab>
  <wlx-tab [title]="'reports.report-files.standard-reports' | translate | titlecase">
    <wl-report-standard-report-files></wl-report-standard-report-files>
  </wlx-tab>
</wlx-tabs>
